import { render, staticRenderFns } from "./BondedWarehouseGoods.vue?vue&type=template&id=0ab88d76"
import script from "./BondedWarehouseGoods.vue?vue&type=script&lang=js"
export * from "./BondedWarehouseGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports